import "../../../css/DesignSystem/Layout/Divider.css";

const Divider = ({ className = "" }) => (
  <hr className={`ds-divider ${className}`.trim()} />
);

export default Divider;
